import { render, staticRenderFns } from "./DashboardHome.vue?vue&type=template&id=b0622112&scoped=true"
import script from "./DashboardHome.vue?vue&type=script&lang=js"
export * from "./DashboardHome.vue?vue&type=script&lang=js"
import style0 from "./DashboardHome.vue?vue&type=style&index=0&id=b0622112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0622112",
  null
  
)

export default component.exports